import {IWeapon} from "../_interfaces/IWeapon";

const weapons_range: IWeapon[] = [
    {
        name: "Blasrohr",
        attr: "ges",
        dmg: 1,
        min_str: 3,
        size: 1,
        ranged: true,
        short_f: 2,
        short_t: 8,
        far_f: 9,
        far_t: 16,
        price: 2,
        weight: 300,
        avail: "Ungewöhnlich"
    },
    {
        name: "Kriegsbogen",
        attr: "ges",
        dmg: 5,
        min_str: 12,
        size: 5,
        ranged: true,
        short_f: 2,
        short_t: 48,
        far_f: 49,
        far_t: 96,
        price: 200,
        weight: 2,
        avail: "Selten"
    },
    {
        name: "Kurzbogen",
        attr: "ges",
        dmg: 3,
        min_str: 8,
        size: 3,
        ranged: true,
        short_f: 2,
        short_t: 30,
        far_f: 31,
        far_t: 60,
        price: 15,
        weight: 1.5,
        avail: "Durchschnittlich"
    },
    {
        name: "Langbogen",
        attr: "ges",
        dmg: 4,
        min_str: 11,
        size: 5,
        ranged: true,
        short_f: 2,
        short_t: 40,
        far_f: 41,
        far_t: 80,
        price: 60,
        weight: 2,
        avail: "Durchschnittlich"
    },
    {
        name: "Schleuder",
        attr: "ges",
        dmg: 2,
        min_str: 5,
        size: 2,
        ranged: true,
        short_f: 2,
        short_t: 20,
        far_f: 21,
        far_t: 40,
        price: 3,
        weight: 0.5,
        avail: "Durchschnittlich"
    },
    {
        name: "Trollschleuder",
        attr: "ges",
        dmg: 4,
        min_str: 10,
        size: 4,
        ranged: true,
        short_f: 2,
        short_t: 30,
        far_f: 31,
        far_t: 60,
        price: 15,
        weight: 2,
        avail: "Durchschnittlich"
    },
    {
        name: "Windlingsbogen",
        attr: "ges",
        dmg: 3,
        min_str: 5,
        size: 2,
        ranged: true,
        short_f: 2,
        short_t: 24,
        far_f: 25,
        far_t: 48,
        price: 25,
        weight: 400,
        avail: "Durchschnittlich"
    }
];
export default weapons_range